import featureFlagNames from './featureFlagNames.json'; // with { type: "json" };

export default Object.freeze(featureFlagNames);
